import {
  Box,
  Chip,
  Skeleton,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";

import type {
  TranslationKey,
  TranslationKeyAndOptions,
} from "@thalamos/vision-common";
import { buildTranslationInput } from "@thalamos/vision-common";

import { Translation } from "../../../Translation/Translation.js";

export type SectionConfig = {
  titleLabel: TranslationKey | TranslationKeyAndOptions;
  emptyLabel: TranslationKey | TranslationKeyAndOptions;
  backgroundColor: string;
  color: string;
};

type SectionSubHeaderRowProps = { config: SectionConfig; colSpan: number } & (
  | { type: "loading" }
  | { type: "loaded"; count: number }
);

/**
 * Show a section header as a row.
 */
export function SectionSubHeaderRow(props: SectionSubHeaderRowProps) {
  return (
    <TableRow className="structural-row">
      <TableCell colSpan={props.colSpan} sx={{ padding: "0.75rem 0" }}>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            gap: 1,
            margin: 1.5,
            marginTop: 4,
          }}
        >
          <Typography
            sx={{
              fontWeight: "bold",
            }}
          >
            <Translation {...buildTranslationInput(props.config.titleLabel)} />
          </Typography>
          <Box sx={{ marginLeft: "0.5rem" }}>
            {props.type === "loading" ? (
              <Skeleton variant="circular" width={"1.5rem"} height={"1.5rem"} />
            ) : (
              <Chip
                data-testid="incident-list-count"
                label={props.count}
                size="small"
                sx={{
                  backgroundColor: props.config.backgroundColor,
                  color: props.config.color,
                }}
              />
            )}
          </Box>
        </Stack>
      </TableCell>
    </TableRow>
  );
}
